import React from "react";

const HeaderSection = () => {
    return (
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-white mb-4">LAVA</h1>
        <h2 className="text-xl font-semibold text-gray-200 ">Language Agnostic Video Anonymization</h2>
      </div>
    );
  };

export default HeaderSection;